<template>
  <div v-if="emplacement">
    <div class="card">
      <header class="header-card">
        <p :class="'obligatoire'">
          {{ $t('adresseEmplacement.caracteristique') }}
        </p>
      </header>
      <div class="card-content">
        <header-emplacement :emplacement="emplacement">
        </header-emplacement>
        <div class="columns mgt-20px">
          <div class="column is-2">
            <b-field :label="$t('adresseEmplacement.domaine')" class="mgt-5px">
              <div class="block">
                <qd-radio v-model="emplacement.emplacementAdresse.domaine"
                         :native-value="publicValue">
                  {{ $t('adresseEmplacement.public') }}
                </qd-radio>
                <qd-radio v-model="emplacement.emplacementAdresse.domaine"
                         :native-value="priveValue">
                  {{ $t('adresseEmplacement.prive') }}
                </qd-radio>
              </div>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('adresseEmplacement.lineaireFacade')">
              <b-input v-model="emplacement.emplacementAdresse.lineaireFacade"
                        type="number"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field v-if="emplacement.adresseCadastrale"
              :label="$t('adresseEmplacement.numeroParcelle')">
              <b-input v-model="emplacement.emplacementAdresse.numeroParcelle"></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('adresseEmplacement.adresse') }}
        </p>
      </header>
      <div class="card-content">
        <adresse-emplacement :adresseCadastraleInformation="emplacement.adresseCadastrale"
                             :showTitle="false">
        </adresse-emplacement>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('adresseEmplacement.pj') }}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes deletable :checkPermissions=checkPermissions(permEmplacement.maj)>
        </app-pieces-jointes>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { PUBLIC, PRIVE } from '@/configuration/gabed/emplacement/emplacementAdresseConf';
import headerEmplacement from '@/components/gabed/emplacement/headerCreationEmplacement';
import adresseEmplacement from '@/components/gabed/emplacement/adresseCreationEmplacement';
import PiecesJointes from '@/components/general/piecesJointes';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    emplacement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      publicValue: PUBLIC,
      priveValue: PRIVE,
    };
  },
  components: {
    headerEmplacement,
    adresseEmplacement,
    appPiecesJointes: PiecesJointes,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};
</script>
